import { render, staticRenderFns } from "./LeftVideo.vue?vue&type=template&id=c7a11a7a&"
var script = {}
import style0 from "./LeftVideo.vue?vue&type=style&index=0&id=c7a11a7a&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports